import React, { useEffect } from "react";
import Button from "~/common/Buttons";
import { ModelFiles } from "~/common/MediaViewerV2/model";
interface SeeIn3DButtonProps {
  modelFiles?: ModelFiles;
}
export const useIsAugmentedRealitySupported = (modelFiles: ModelFiles | undefined, setShowAugmentedRealityButton: React.Dispatch<React.SetStateAction<boolean>>) => {
  useEffect(() => {
    const loadArkitSupported = async () => {
      const {
        default: isArkitSupported
      } = await import("~/common/helpers/isArkitSupported");
      if (isArkitSupported()) {
        setShowAugmentedRealityButton(!!modelFiles?.relativeUsdzFilePath);
      }
    };
    loadArkitSupported();
  }, [modelFiles, setShowAugmentedRealityButton]);
};
export const SeeIn3DButton = ({
  modelFiles
}: SeeIn3DButtonProps) => {
  return modelFiles ? <Button href={modelFiles.relativeUsdzFilePath} data-arkit-file={modelFiles.relativeUsdzFilePath} rel="ar" color="custom" data-3dpreview="data-3dmodel-mobile-button" data-testid="data-3dmodel-mobile-button" className="bg-white border-gray-200 flex items-center justify-center font-normal text-base mt-2 px-10 text-black w-full" data-sentry-element="Button" data-sentry-component="SeeIn3DButton" data-sentry-source-file="SeeIn3DButton.tsx">
      <img src="//cdnimg.webstaurantstore.com/uploads/design/2019/4/ar-3d-icon.png" className="mr-2 w-8" alt="See it in 3d" />
      <span>
        See it in your space in <strong>3D</strong>
      </span>
    </Button> : <></>;
};